const paymentConstants = Object.freeze({
  PAYMENT_METHOD_CARD: 'Card',
  PAYMENT_METHOD_APPLE_PAY: 'Apple Pay',
  PAYMENT_METHOD_GOOGLE_PAY: 'Google Pay',
  // Stripe's customer portal login: the member enters their email and Stripe
  // mails them a sign-in link. Same link PaymentService (portalDefaultUrl) and
  // the iOS app (stripeCustomerPortalFallbackUrl) fall back to.
  STRIPE_CUSTOMER_PORTAL_LOGIN_URL:
    'https://billing.stripe.com/p/login/3csbKqaFd90H7bG6oo',
  // The 40% coupon of the failed-renewal recovery offer (PROD-7062). Like the
  // pricing coupons (data/pricing.json and pricing-dev.json), the production
  // one is for production and test builds, the dev one for every other build.
  RECOVERY_OFFER_COUPON_ID: 'Vq2jCghL',
  RECOVERY_OFFER_COUPON_ID_DEV: 'adNTjega',
  THREE_SKU_SUPPORTED_COUNTRIES: [
    'US',
    'CA',
    'AU',
    'NZ',
    'UK',
    'ES',
    'DE',
    'FR',
    'MX',
  ],
});

export default paymentConstants;
